var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-message-container"},[_c('div',{staticClass:"icon-container"},[_c('i',{class:_vm.data.icon})]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }